module.exports = __webpack_public_path__ + "static/project-2-2-d72ec2142a9bd1883a9fb3463efbb8d3.jpg";